import axios from 'axios'
import router from '../router/index.js'
import {
	MessageBox,
	Message
} from 'element-ui'
let baseURL = ''
if (process.env.VUE_APP_ENV == 'web') {
	baseURL = 'https://' +  window.location.host
}
import Cookies from 'js-cookie'
console.log(process.env.VUE_APP_ENV)
console.log('baseURL',baseURL)
let timeout = 30000;
// 创建实例时配置默认值
axios.defaults.withCredentials = true;
const instance = axios.create({
	baseURL,
	timeout,
	withCredentials: true,
});

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
	// 2xx 范围内的状态码都会触发该函数。
	// 对响应数据做点什么
	// console.log('responseresponse', response)
	return response;
}, function(error) {
	console.log('errorerrorerror', error)
	if(error.status == 401) {
		console.log('router',router)
		// str.startsWith("Hello");
		// router.push({
		// 	path:"/login"
		// })
		
		Cookies.set('login', '');
		Cookies.set('weimei_session', '');
		Cookies.set('XSRF-TOKEN', '');
		if(process.env.NODE_ENV != 'development' && !window.location.pathname.startsWith('/products') && !window.location.pathname.startsWith('/categories') && error.config.url != 'account/collect') {
			
			
			router.replace({
				path:"/userlogin"
			})
			return
		}
		console.log('Location',(window.location.pathname.startsWith('/products') || window.location.pathname.startsWith('/categories')))
		console.log('error.config.url',error.config.url)
		Message({
			showClose: true,
			message: error.response.data.message,
			type: 'error'
		});
		
	}else if(error.status == 422){
		Message({
			showClose: true,
			message: error.response.data.message,
			type: 'error'
		});
	}else {
		Message({
			showClose: true,
			message: error.message,
			type: 'error'
		});
	}
	
	// 超出 2xx 范围的状态码都会触发该函数。
	// 对响应错误做点什么
	return Promise.reject(error);
});
export default instance